import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const FolderStructureIcon = forwardRef<SVGSVGElement, IconProps>(function FolderStructureIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg ref={ref} width={width} height={height} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M4 9.5C4 10.3284 3.32843 11 2.5 11C1.67157 11 1 10.3284 1 9.5C1 8.67157 1.67157 8 2.5 8C3.32843 8 4 8.67157 4 9.5Z"
        stroke={color || 'currentColor'}
      />
      <path
        d="M11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5Z"
        stroke={color || 'currentColor'}
      />
      <path
        d="M9.5 8C9.42166 6.77351 8.98436 6.5 7.50595 6.5H4.49405C3.01563 6.5 2.57834 6.77351 2.5 8"
        stroke={color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5H6.28125C7.07126 5 7.46627 5 7.75002 4.81274C7.87286 4.73168 7.97832 4.62751 8.0604 4.50619C8.25 4.22594 8.25 3.83581 8.25 3.05556C8.25 2.5874 8.25 2.35332 8.13624 2.18518C8.087 2.11238 8.02371 2.04988 7.95001 2.00124C7.77976 1.88889 7.54276 1.88889 7.06875 1.88889H6.32127C6.25629 1.88889 6.2238 1.88889 6.19395 1.88456C6.08223 1.86836 5.98233 1.80772 5.91792 1.71701C5.90072 1.69278 5.8863 1.66431 5.85748 1.60736C5.7394 1.37413 5.6315 1.13936 5.36983 1.04245C5.25523 1 5.1243 1 4.86246 1C4.45375 1 4.2494 1 4.09606 1.08451C3.98676 1.14476 3.89657 1.23384 3.83557 1.34179C3.75 1.49324 3.75 1.69507 3.75 2.09873V2.77778C3.75 3.82534 3.75 4.34913 4.0795 4.67456C4.40901 5 4.93934 5 6 5Z"
        stroke={color || 'currentColor'}
        strokeLinecap="round"
      />
    </svg>
  );
});
